import React, { useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart';
import { fetchData } from '../../service/dataServices';
import { Card, Col, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

export default function DonutCard() {
  const { t } = useTranslation();
  
  const options = [
    'classification',
    'category',
    'region',
    'location',
    'locationArea',
  ];

  const colors = ['#69B1FF', '#95de64', '#5cdbd3', '#ffc069', '#003EB3', '#002C8C', '#001D66']

  const [data, setData] = useState([]);
  const [total, setTotal] = useState();
  const [ddType, setDdType] = useState('classification');

  const { isLoading } = fetchData('/api/dashboard/object-dropdowns', data => {
    const res = data.map((d, i) => {
      return {
        title: d.x,
        value: d.y,
        color: colors[i],
      }
    })
    setData(res);
    setTotal(data.reduce((pre, now) => now.y + pre, 0));
  }, { groupBy: ddType });

  const handleChange = (val) => {
    setDdType(val);
  }

  return (
    <Card
      loading={isLoading}
      title={t("dashboard.donutCard_title")}
      style={{ height: '100%' }}
      styles={{
        header: { color: '#00000073', fontSize: '14px' },
        body: { alignItems: 'center', height: '100%' }
      }}
      extra={
        <Select defaultValue="classification" style={{ width: 220 }} onChange={handleChange}>
          {options.map(option => (
            <Option key={option} value={option}>
              {t(`objects.${option}`, option)}
            </Option>
          ))}
        </Select>
      }>

      <Row align='middle' justify='space-evenly' style={{ height: '100%' }}>
        <Col>
          <PieChart
            data={data}
            lineWidth={20}
            // paddingAngle={2}
            // rounded
            labelPosition={0}
            animate
          />
        </Col>
        <Col>
          <ul>
            {data.map((entry, index) => (
              <li key={index} className="flex items-center mb-2">
                <span
                  className="w-4 h-4 mr-2 inline-block"
                  style={{ backgroundColor: entry.color }}
                ></span>
                <span className="text-gray-700">
                  {t(`dashboard.chart_labels.${entry.title}`, entry.title)} ({((entry.value / total) * 100).toFixed(2)}%)
                </span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </Card>
  )
}